export const contactInfo = {
  name: "Mette Brisson",
  title: "Psykolog med praksisuddannelse",
  address: "Behandlerkollektivet, Holger Danskes vej 3B",
  zipCity: "2000 Frederiksberg",
  phone: "27 89 30 29",
  email: "mettebrisson@protonmail.com",
  cvr: "44759446",
  hours: [],
  pricing: {
    individual: "1200 kr (60 min)",
    couple: "1800 kr (90 min)",
    family: "1800 kr (90 min)",
    supervision: "1200 kr (60 min)"
  }
};

export const fallbackYdelser = [
  {
    id: "b32fbc39-c495-4c2a-9b8f-2fb19d7310a9",
    titel: { da: "Forældreskab og efterfødselsreaktioner" },
    kort_beskrivelse: { da: "Behandling af efterfødselsreaktioner hos mænd og kvinder samt støtte til forældreskab." },
    beskrivelse: { da: "<p>Jeg har erfaring med at samarbejde med børn 0-16 år og forældre i svære situationer. Jeg er uddannet COS-P vejleder, som kan være et tilbud til dig som forælder til et barn i alderen 0-5 år, som er nysgerrig på hvordan du kan forstå dit barns adfærd, samt gå på opdagelse i hvad du bringer med dig i et forældreskab. Jeg har erfaring med at behandle efterfødselsreaktioner hos mænd og kvinder og har erfaring for at det der særligt skal være fokus på er dels at normalisere at det ikke altid er lykken at blive forældre samt at se på hvordan vi sammen kan nedbringe den skam og selvkritik der ofte er forbundet med en efterfødselsreaktion.</p>" },
    billede: ["https://assets.auxodev.dk/assets/4291744f-0a58-4691-8a7f-39ecbae78b95/foraeldreskab-symbolsk.jpg"],
    ydelse_slug: { da: "foraeldreskab-og-efterfoedselsreaktioner" }
  },
  {
    id: "e54fa23b-eb03-4c62-83f2-1f4359d520ff",
    titel: { da: "NARM terapi" },
    kort_beskrivelse: { da: "NARM er en metode, som integrerer en kropslig og psykologisk tilgang." },
    beskrivelse: { da: "<p>NARM er en metode, som integrerer en kropslig og psykologisk tilgang. Er særligt velegnet til behandling af CPTSD, tilknytningsproblematikker, udviklingstraumer og en måde at gå på opdagelse i hvor fx selvkritik og udskamning stammer fra.</p>" },
    billede: ["https://assets.auxodev.dk/assets/4291744f-0a58-4691-8a7f-39ecbae78b95/narm-natur-rolig.jpg"],
    ydelse_slug: { da: "narm-terapi" }
  },
  {
    id: "709ee25a-3d54-49cb-ac6b-9f19c57ceb4f",
    titel: { da: "Parterapi" },
    kort_beskrivelse: { da: "Støtte til at bryde fastlåste mønstre, forbedre kommunikationen eller finde en respektfuld afslutning." },
    beskrivelse: { da: "<p>Parterapi kan som udgangspunkt være gavnligt for alle parforhold, men de par der særligt kommer i parterapi oplever fx at være fastlåst i et mønster, hvor det især især vanskeligt at kommunikere, har oplevet tillidsbrud eller savner at komme tættere på hinanden. Nogle opsøger også parterapi for at finde ud af sammen på en respektfuld og ordentlig måde om parforholdet skal afsluttes.</p>" },
    billede: ["https://assets.auxodev.dk/assets/4291744f-0a58-4691-8a7f-39ecbae78b95/parterapi.jpg"],
    ydelse_slug: { da: "parterapi" }
  },
  {
    id: "0cbc42a9-54fd-4432-b77c-32b244ca6f40",
    titel: { da: "Supervision" },
    kort_beskrivelse: { da: "Individuel eller gruppesupervision til professionelle, der arbejder med børn og unge." },
    beskrivelse: { da: "<p>Jeg har erfaring med at tilbyde individuel eller gruppe supervision til dig/jer der er professionelle og arbejder med børn, og har brug for supervision på jeres arbejde. I supervisionen vil vi sammen være nysgerrige på hvordan arbejdet påvirker jer som professionelle og se på om vi kan få øje på andre handlemuligheder.</p>" },
    billede: ["https://assets.auxodev.dk/assets/4291744f-0a58-4691-8a7f-39ecbae78b95/supervision.jpg"],
    ydelse_slug: { da: "supervision" }
  },
  {
    id: "34aac168-0882-4b55-832e-fd01c6118698",
    titel: { da: "Familieterapi" },
    kort_beskrivelse: { da: "Støtte til at styrke relationer, løse konflikter og skabe bedre forståelse i familien." },
    beskrivelse: { da: "<p>Familieterapi er et tilbud til familier, der oplever fastlåste mønstre, kommunikationsvanskeligheder eller står overfor store livsændringer. I terapien skaber vi et trygt og fordomsfrit rum, hvor alle familiemedlemmer kan blive hørt og forstået.</p><p>Vi arbejder med at styrke jeres indbyrdes relationer, genfinde respekten og opbygge sundere måder at kommunikere og være sammen på i hverdagen.</p>" },
    billede: ["https://assets.auxodev.dk/assets/4291744f-0a58-4691-8a7f-39ecbae78b95/familieterapi.jpg"],
    ydelse_slug: { da: "familieterapi" }
  },
  {
    id: "stress",
    titel: { da: "Stress & Udbrændthed" },
    kort_beskrivelse: { da: "Lær at genkende kroppens signaler, genopbyg din energi og skab holdbare grænser i din hverdag." },
    beskrivelse: { da: "<p>Stress er en naturlig reaktion på overbelastning, men når den bliver kronisk, slider den på både krop og sind. I terapien arbejder vi med at forstå dine stressudløsere, genfinde balancen og opbygge konkrete redskaber til at passe på dig selv.</p><p>Gennem samtalerne vil du få hjælp til at genkende kroppens advarselssignaler, genopbygge din energi og skabe sunde, holdbare grænser i både dit professionelle og personlige liv.</p>" },
    billede: ["https://assets.auxodev.dk/assets/4291744f-0a58-4691-8a7f-39ecbae78b95/6fe25267-fac3-4f86-ad2f-975d9bdf41da.jpg"],
    ydelse_slug: { da: "stress-og-udbraendthed" }
  },
  {
    id: "angst",
    titel: { da: "Angst & Bekymring" },
    kort_beskrivelse: { da: "Få redskaber til at berolige dit nervesystem, bryde negative tankemønstre og genvinde din frihed." },
    beskrivelse: { da: "<p>Angst kan føles overvældende og begrænsende i hverdagen. Det kan komme to udtryk som hjertebanken, uro, katastrofetanker eller undgåelsesadfærd. I et trygt og roligt rum undersøger vi, hvad der udløser din angst.</p><p>Vi arbejder med kognitive redskaber og kropslige øvelser, der beroliger dit nervesystem, så du gradvist kan genvinde din frihed og handlekraft uden at være styret av frygt.</p>" },
    billede: ["https://assets.auxodev.dk/assets/4291744f-0a58-4691-8a7f-39ecbae78b95/45ab40ce-ffe4-4645-9b62-523934f3779b.jpg"],
    ydelse_slug: { da: "angst-og-bekymring" }
  },
  {
    id: "krise",
    titel: { da: "Livskriser & Sorg" },
    kort_beskrivelse: { da: "Støtte og vejledning, når livet slår sprækker, og du skal finde fodfæste i en ny virkelighed." },
    beskrivelse: { da: "<p>Når vi mister, oplever skilsmisse, sygdom eller andre store omvæltninger, kan fundamentet under os ryste. Sorg og krise er naturlige reaktioner på svære livsomstændigheder, men det kan være ensomt at stå i alene.</p><p>Her får du et rum, hvor alle følelser er tilladte. We arbejder på at rumme smerten, finde mening i det meningsløse og langsomt genopbygge et solidt fodfæste i din nye virkelighed.</p>" },
    billede: ["https://assets.auxodev.dk/assets/4291744f-0a58-4691-8a7f-39ecbae78b95/livskriser-sorg-symbolsk.jpg"],
    ydelse_slug: { da: "livskriser-og-sorg" }
  },
  {
    id: "selvvaerd",
    titel: { da: "Selvværd & Personlig Udvikling" },
    kort_beskrivelse: { da: "Styrk din indre dialog, lær at acceptere dig selv og træd i karakter som den, du reelt er." },
    beskrivelse: { da: "<p>Et lavt selvværd kan spænde ben for vores drømme, relationer og livsglæde. Det viser sig ofte som en hård indre kritiker, pleaser-adfærd eller en konstant følelse af ikke at være god nok.</p><p>I terapien arbejder vi med at styrke din indre dialog og opbygge en dybere selvaccept. Vi undersøger de gamle mønstre, der holder dig tilbage, så du kan træde i karakter med større selvtillid og autenticitet.</p>" },
    billede: ["https://assets.auxodev.dk/assets/4291744f-0a58-4691-8a7f-39ecbae78b95/fbb2aa06-37b7-4bae-a756-4cda0cd33d77.jpg"],
    ydelse_slug: { da: "selvvaerd-og-personlig-udvikling" }
  }
];

export const fallbackUdtalelser = [
  {
    id: "1",
    navn: "Anonym klient",
    baggrund: { da: "Kvinde, 31 år (Angstforløb)" },
    citat: { da: "<p>Mette har givet mig et trygt og fordomsfrit rum til at tale om min angst. Hendes rolige væsen og konkrete redskaber har hjulpet mig med at få kontrollen over min hverdag tilbage.</p>" }
  },
  {
    id: "2",
    navn: "Anonym klient",
    baggrund: { da: "Mand, 45 år (Livskrise)" },
    citat: { da: "<p>Efter en svær skilsmisse følte jeg mig fuldstændig tabt. Hos Mette fandt jeg den støtte og refleksion, jeg havde brug for til at genopbygge mit selvværd og finde fodfæste igen.</p>" }
  },
  {
    id: "3",
    navn: "Anonym klient",
    baggrund: { da: "Kvinde, 38 år (Stressforløb)" },
    citat: { da: "<p>Jeg kan varmt anbefale Mette. Hendes evne til at lytte og stille de rigtige, kærlige spørgsmål har givet mig en helt ny forståelse af mine stressmønstre.</p>" }
  },
  {
    id: "4",
    navn: "Par, Frederiksberg",
    baggrund: { da: "Parterapi" },
    citat: { da: "<p>Gennem parterapi hos Mette har vi fundet tilbage til hinanden. Vi har fået konkrete redskaber til at kommunikere uden at ende i de samme gamle konflikter.</p>" }
  },
  {
    id: "5",
    navn: "Anonym klient",
    baggrund: { da: "Mand, 52 år (Udbrændthed)" },
    citat: { da: "<p>Mette hjalp mig igennem en svær periode med udbrændthed på mit arbejde. Hendes professionelle og medfølende tilgang gav mig modet til at træffe de nødvendige valg.</p>" }
  }
];

export const sortServices = (servicesList) => {
  if (!Array.isArray(servicesList)) return [];
  return [...servicesList].sort((a, b) => {
    const titleA = (a.titel?.da || a.titel || '').toLowerCase();
    const titleB = (b.titel?.da || b.titel || '').toLowerCase();

    const isA_Familie = titleA.includes('forældreskab') || titleA.includes('foraeldreskab');
    const isB_Familie = titleB.includes('forældreskab') || titleB.includes('foraeldreskab');

    const isA_Narm = titleA.includes('narm');
    const isB_Narm = titleB.includes('narm');

    // Familiedannelse should be first
    if (isA_Familie && !isB_Familie) return -1;
    if (!isA_Familie && isB_Familie) return 1;

    // NARM should be second
    if (isA_Narm && !isB_Narm) return -1;
    if (!isA_Narm && isB_Narm) return 1;

    return 0;
  });
};
